/**
 * @file 二维码登录布局
 * @author hanzhichen(hanzhichen@baijia.com)
 * @date 2020-12-15
 */
import PropTypes from 'prop-types';

function BlankLayout(props) {
    const {children} = props;
    return (
        <div className="blank-layout">
            {children}
        </div>
    );
}

BlankLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default BlankLayout;
